import { useState, useEffect, useRef,useMemo } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import Templates from "./component/template";
import TemplatePopup from "./component/TemplatePopup";
import { templatePopups } from "./data/templatePopups";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  
  const [activeTab, setActiveTab] = useState("top");

  const [popUp, setPopUp] = useState(null);
  const showPopup = (id) => {
    document.body.classList.add("no-scroll");
    setPopUp(id); // Save the template ID
  };

  const closePopup = () => {
    setPopUp(null);
    document.body.classList.remove("no-scroll");
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [colorTheme, colorThemeSelected] = useState("1");

  const colorThemeSelect = (value) => {
    colorThemeSelected(value);
  };
  const imgContainerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const openFullscreen = () => {
    const elem = imgContainerRef.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
  };
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFull =
        document.fullscreenElement === imgContainerRef.current ||
        document.webkitFullscreenElement === imgContainerRef.current ||
        document.msFullscreenElement === imgContainerRef.current;

      setIsFullscreen(isFull);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const recommendedTemplates = useMemo(() => {
    return templatePopups.filter((template) => template.recommendation);
  }, [templatePopups]);
  
  const otherTemplates = useMemo(() => {
    return templatePopups.filter((template) => !template.recommendation);
  }, [templatePopups]);

  const templatesToShow = useMemo(
    () => (activeTab === "top" ? recommendedTemplates : otherTemplates),
    [activeTab, recommendedTemplates, otherTemplates]
  );
  const activeTemplate = templatePopups.find((t) => t.id === popUp) || null;

  return (
    <div className="App">

    <div className="sticky-top-portion">
      <div className="main-page">
        <img
          src="https://webapi.entab.info/api/image/ENTAB/public/Images/logo.webp"
          className="img-fluid"
          alt="Entab"
        />
      </div>
<div className="template_message">
      <h1 className="text-center">Choose Templates</h1>
      <h1 className="blue half-line">
        That suits best for <span>you</span>
      </h1>
     
      <div className="container-fluid mt-4">
        {(recommendedTemplates.length > 0 || otherTemplates.length > 0) && (
          <h2 className="text-center mb-3 section-heading">
          <ul className="nav justify-content-center">
  <li className="nav-item">
    <a
      className={`nav-link ${activeTab === "top" ? "active" : ""}`}
      href="#"
      onClick={(e) => {
        e.preventDefault();
        setActiveTab("top");
      }}
    >
      LATEST TEMPLATES CHOICE
    </a>
  </li>

  <li className="nav-item">
    <a
      className={`nav-link ${activeTab === "other" ? "active" : ""}`}
      href="#"
      onClick={(e) => {
        e.preventDefault();
        setActiveTab("other");
      }}
    >
      WIDELY USED TEMPLATES
    </a>
  </li>
</ul>
          </h2>
          
        )}
        </div>
         </div>
        </div>
        {/*<div className="row">
          {recommendedTemplates.map((template) => (
            <Templates
              key={template.id}
              id={template.id}
              imgName={template.imgName}
              showPopUp={showPopup}
            />
          ))}

          {recommendedTemplates.length > 0 && otherTemplates.length > 0 && (
            <div className="col-12 my-3">
              <hr />
            </div>
          )}

          {recommendedTemplates.length > 0 && otherTemplates.length > 0 && (
            <div className="col-12">
              <h2 className="text-center mb-3 section-heading">
                Other Sample Templates
              </h2>
            </div>
          )}

          {otherTemplates.map((template) => (
            <Templates
              key={template.id}
              id={template.id}
              imgName={template.imgName}
              showPopUp={showPopup}
            />
          ))}
        </div>
      </div>
      {templatePopups.map((template) => (
        <TemplatePopup
          key={template.id}
          isOpen={popUp === template.id}
          onClose={closePopup}
          settings={settings}
          colorTheme={colorTheme}
          onColorSelect={colorThemeSelect}
          imgContainerRef={imgContainerRef}
          isFullscreen={isFullscreen}
          onOpenFullscreen={openFullscreen}
          template={template}
        />
      ))}
      </div>
  );
}*/}

        <div className="row">
          {templatesToShow.map((template) => (
            <Templates
              key={template.id}
              id={template.id}
              imgName={template.imgName}
              showPopUp={showPopup}
            />
          ))}
          </div>

         

          {activeTemplate && (
            <TemplatePopup
              isOpen={true}
              onClose={closePopup}
              settings={settings}
              colorTheme={colorTheme}
              onColorSelect={colorThemeSelect}
              imgContainerRef={imgContainerRef}
              isFullscreen={isFullscreen}
              onOpenFullscreen={openFullscreen}
              template={activeTemplate}
            />
          )}
      </div>
  );


}

export default App;
